import { get, post } from '../components/library/api/rest/index';
import { getStaticBaseUrl } from '../utils/publicUrl';
const getBaseUrl = () => getStaticBaseUrl();
/**
 * Load page definition from public JSON (e.g. /pages/landing.json).
 * If the loaded JSON has source.url, fetches that URL and uses the response as the page definition
 * (so content can come from a service).
 */
export async function loadPageDefinition(pagePath) {
    const base = getBaseUrl();
    const url = pagePath.startsWith('http') ? pagePath : `${base.replace(/\/?$/, '/')}${pagePath.replace(/^\//, '')}`;
    const data = (await get(url, null, null, null));
    if (!data)
        throw new Error('Failed to load page');
    if (data.source?.url) {
        const sourceUrl = data.source.url.startsWith('http') ? data.source.url : `${base}/${data.source.url.replace(/^\//, '')}`;
        const sourceData = (await get(sourceUrl, null, null, null));
        if (!sourceData)
            throw new Error('Failed to load page source');
        return { ...data, ...sourceData };
    }
    return data;
}
function postReturnedError(body) {
    return typeof body === 'object' && body !== null && 'isError' in body && body.isError === true;
}
/**
 * Fetch API data for a section and map to props.
 */
export async function fetchSectionProps(api, staticProps = {}) {
    const base = getBaseUrl();
    const url = api.url.startsWith('http') ? api.url : `${base.replace(/\/?$/, '/')}${api.url.replace(/^\//, '')}`;
    const method = (api.method ?? 'GET').toUpperCase();
    let data = null;
    if (method === 'POST') {
        const raw = await post(url, {}, null, null, null);
        if (raw == null || postReturnedError(raw))
            throw new Error('API failed');
        data = raw;
    }
    else if (method === 'GET') {
        const raw = await get(url, null, null, null);
        if (raw == null)
            throw new Error('API failed');
        data = raw;
    }
    else {
        throw new Error(`Unsupported section API method: ${String(api.method)}`);
    }
    const mapped = {};
    if (api.propMap) {
        for (const [apiKey, propName] of Object.entries(api.propMap)) {
            if (apiKey in data)
                mapped[propName] = data[apiKey];
        }
    }
    else {
        Object.assign(mapped, data);
    }
    return api.merge === 'replace' ? mapped : { ...staticProps, ...mapped };
}
